/**
* @Description 文件功能说明：上传预览弹窗
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <div v-if="dialogTreeItem.dialogFormVisible">
        <el-dialog :title="dialogTreeItem.title"
                   :visible.sync="dialogTreeItem.dialogFormVisible"
                   :close-on-click-modal="false"
                   :modal-append-to-body="false"
                   custom-class="form-dialog"
                   v-dialogDrag
                   class="dialog_title"
                   @close="handleDialogClose"
        >
            <!-- 表格 -->
            <DynamicTable ref="dynamicTable"
                          :previewTitle="previewTitle"
                          :previewData="previewData"
                          :selectBox="true"
                          :optionButton="false"
                          @selectRow="selectRow"
                          @selectRows="selectRows"
                          :showSerialNumber="showSerialNumber"
            />

            <el-form v-if="dialogTreeItem.submitButton != ''" style="margin-bottom: 60px;">
                <el-form-item style="float: left;color: #ffffff;">
                    <span>已选中 </span><span style="font-weight: bold;">{{selectNum}}</span> <span>个</span>
                </el-form-item>
                <el-form-item style="float: right;">
                    <el-button type="primary" @click.native="submit" size="mini">{{dialogTreeItem.submitButton}}</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>

</template>

/* JS */
<script>

import DynamicTable from '@/components/DynamicTable.vue'

export default {

    /**
     * @Des 组件名
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    name: 'UploadDialog',

    /**
     * @Des 组件引用
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    components: {
        // 动态表格
        DynamicTable
    },

    /**
     * @Des 数据接收类型
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    props: {

        /**
         * @Des 标题数据类型
         * @Auth Zhangbin
         * @Date 17:23 2021/4/30
         */
        previewTitle: {
            type: Array,
            default: function (){
                return []
            }
        },

        /**
         * @Des 表格数据类型
         * @Auth Zhangbin
         * @Date 17:23 2021/4/30
         */
        previewData: {
            type: Array,
            default: function (){
                return []
            }
        },

        /**
         * @Des 上传地址类型
         * @Auth Zhangbin
         * @Date 17:23 2021/4/30
         */
        uploadUrl: {
            type: String,
            default: function (){
                return ''
            }
        },

        /**
         * @Des 是否显示序号
         * @Auth Zhangbin
         * @Date 17:23 2021/4/30
         */
        showSerialNumber: {
            type: Boolean,
            default: function (){
                return true
            }
        }
    },

    /**
     * @Des 数据定义
     * @Auth Zhangbin
     * @Date 17:23 2021/4/30
     */
    data() {
        return{

            /**
             * @Des 弹出层属性
             * @Auth Zhangbin
             * @Date 17:23 2021/4/30
             */
            dialogTreeItem: {
                title: '',
                dialogFormVisible: false,
                submitButton: '',
            },
            // 上传数据集合
            uploadData: [],
            // 选择的数量
            selectNum: 0
        }
    },

    /**
     * @Des 方法定义
     * @Auth Zhangbin
     * @Date 17:24 2021/4/30
     */
    methods: {

        /**
         * @Des 打开弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        openDialog(title, button){
            this.dialogTreeItem.title = title;
            this.dialogTreeItem.dialogFormVisible = true;
            this.dialogTreeItem.submitButton = button;
        },

        /**
         * @Des 关闭弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        handleDialogClose(){
            this.$refs.dynamicTable.cleanSelect();
            this.dialogTreeItem.dialogFormVisible = false;
            this.$emit("reSearch");
        },

        /**
         * @Des 选择行处理
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        selectRow(row, selection){
            // console.log(row, selection.length);
            this.selectNum = selection.length;
        },

        /**
         * @Des 选择多行处理
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        selectRows(rows){
            // console.log(row, selection.length);
            this.selectNum = rows.length;
        },

        /**
         * @Des 数据提交
         * @Auth Zhangbin
         * @Date 17:49 2021/4/30
         */
        submit(){
            this.uploadData = this.$refs.dynamicTable.getSelection();
            // console.log(this.uploadData); return false;
            if(this.uploadData.length == 0){
                this.$message({
                    message: '请选择要上传的数据',
                    type: 'warning',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            if(this.uploadUrl == ''){
                this.$message({
                    message: '上传路径找不到！',
                    type: 'warning',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            let num = this.uploadData.length;
            this.uploadData.forEach((row, index) => {
                let params = {
                    typeId: row.typeId,
                    groupId: row.groupId,
                    groupName: row.groupName,
                    userName: row.userName,
                    sex: row.sex,
                    phoneCode: row.phoneCode,
                    phone: row.phone,
                    idCard: row.idCard,
                    portrait: row.portrait,
                    duty: row.duty,
                    tagId: row.tagId,
                    remarks: row.remarks,
                    projectId: this.$store.state.currentProjectId
                };
                this.$request.postJsonRequest(this.uploadUrl,params).then(result => {
                    if(result.code == 0){
                        row["message"] = '上传成功';
                    }else{
                        row["message"] = result.msg;
                    }
                    if(num == index + 1){
                        this.$message({
                            message: '数据处理完毕',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(error => {
                    row["message"] = '上传异常';
                    console.error('上传异常', this.uploadUrl, error);
                });
            });
        }
    },

}
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		margin-top: 100px;
		width: 80%;
	}
</style>



// WEBPACK FOOTER //
// src/components_pages/User/UploadDialog.vue